import styled from '@emotion/styled';
import { Button } from '@material-ui/core';
import _AddCircle from '@material-ui/icons/AddCircle';
import _LibraryBooks from '@material-ui/icons/LibraryBooks';
import { createElement, FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import Language from '../../../entity/Language';
import { OrganizationDetailFragment, SingleDirectorUserFragment } from '../../../generated/graphql';
import { SPACING_HUGE, SPACING_UNIT } from '../../constant/spacing';

type Props = {
  projectsLoading: boolean;
  showEmptyProject: boolean;
  redirectToDirectionTypes: () => void;
  organization: OrganizationDetailFragment | null;
  user: SingleDirectorUserFragment | null;
  language: Language;
  setModal: (state: boolean) => void;
  onGoToProjectClick: () => void;
};

const ProjectsNavButton: FC<Props> = ({
  projectsLoading,
  showEmptyProject,
  organization,
  redirectToDirectionTypes,
  setModal,
  language,
  user,
  onGoToProjectClick,
}) => {
  // 新規プロジェクト作成時のRegion別処理を実行
  const handleClickNewProjectButton = () => {
    if (organization) {
      const region = organization.businessRegion.key;

      switch (region) {
        case 'us':
        case 'gl':
        case 'jp':
          redirectToDirectionTypes();
          break;
        default:
          break;
      }
    } else if (user) {
      // Organizationが存在しない場合、モーダルを表示してIDへの組織登録を促す
      // Organization.BusinessRegionを参照できないため、Langを参照する
      // https://kaizen.qiita.com/yuta-yamamoto/items/7d1a72e3d01ec3c5ec8f

      switch (language) {
        case 'ja-JP':
          redirectToDirectionTypes();
          break;
        case 'en-US':
          setModal(true);
          break;
        default:
          break;
      }
    }
  };

  return (
    <NavContainer>
      {!projectsLoading && (
        <Fragment>
          {showEmptyProject ? (
            <Button
              onClick={handleClickNewProjectButton}
              disabled={projectsLoading}
              variant="contained"
              color="primary"
              style={{ textTransform: 'none' }}
              fullWidth
            >
              <AddCircle fontSize="small" />
              <FormattedMessage id="latest_insights_page.create_new_project" />
            </Button>
          ) : (
            <Button
              onClick={onGoToProjectClick}
              disabled={projectsLoading}
              variant="outlined"
              color="primary"
              style={{ textTransform: 'none' }}
              fullWidth
            >
              <LibraryBooks fontSize="small" />
              <FormattedMessage id="latest_insights_page.navigate_to_projects" />
            </Button>
          )}
        </Fragment>
      )}
    </NavContainer>
  );
};

const NavContainer = styled('div')`
  max-width: 320px;
  margin: ${SPACING_HUGE}px auto;
`;

const ButtonIcon = {
  marginRight: SPACING_UNIT,
};

const AddCircle = styled(_AddCircle)(ButtonIcon, {
  color: '#fff',
});

const LibraryBooks = styled(_LibraryBooks)(ButtonIcon);

export default ProjectsNavButton;
